import { createTheme } from '@mui/material';

const theme = createTheme({
  typography: {
    fontFamily: 'JetBrains Mono, Fira Code, SF Mono, Consolas, monospace',
    h1: {
      fontSize: '5rem',
      fontWeight: '600',
    },
    h2: {
      fontSize: '2.5rem',
      fontWeight: '400',
    },
    h3: {
      fontSize: '1.5rem',
      fontWeight: '400',
    },
    body: {
      fontSize: '1rem',
      fontWeight: '400',
    }
  },
  palette: {
    // Professional space-themed palette inspired by Monokai Pro
    primary: {
      main: '#78DCE8', // Stellar blue - reminiscent of distant stars
      light: '#9CE8F0', // Lighter stellar blue
      dark: '#5BC8DC', // Deeper stellar blue
      contrastText: '#1E1F29',
    },
    secondary: {
      main: '#AB9DF2', // Cosmic purple - nebula-inspired
      light: '#C4B8F5', // Lighter cosmic purple
      dark: '#9485ED', // Deeper cosmic purple
      contrastText: '#1E1F29',
    },
    background: {
      default: 'rgba(30, 31, 41, 0.95)', // Space-like translucent background
      paper: 'rgba(40, 42, 54, 0.9)', // Slightly lighter for cards/panels
    },
    text: {
      primary: '#FCFCFA', // Bright starlight white
      secondary: '#939293', // Muted cosmic dust
    },
    info: {
      main: '#78DCE8', // Stellar blue
    },
    success: {
      main: '#A9DC76', // Aurora green
    },
    warning: {
      main: '#FFD866', // Solar yellow
    },
    error: {
      main: '#FF6188', // Supernova pink
    },
    // Custom space-themed Monokai Pro colors
    monokai: {
      // Backgrounds
      background: 'rgba(30, 31, 41, 0.95)', // Main space background
      backgroundLight: 'rgba(40, 42, 54, 0.9)', // Lighter panels
      backgroundLighter: 'rgba(50, 52, 64, 0.85)', // Even lighter sections
      backgroundGlass: 'rgba(30, 31, 41, 0.7)', // For glass-morphism effects
      
      // Text colors
      foreground: '#F8F8F2', // Bright starlight
      foregroundDim: '#CCCCCC', // Dimmed starlight
      comment: '#75715E', // Cosmic dust
      
      // Accent colors (space-themed Monokai Pro)
      stellar: '#78DCE8', // Stellar blue
      nebula: '#AB9DF2', // Nebula purple/magenta
      aurora: '#A9DC76', // Aurora green
      solar: '#FFD866', // Solar yellow
      supernova: '#FF6188', // Supernova pink/red
      cosmic: '#FC9867', // Cosmic orange
      
      // Utility colors
      white: '#FFFFFF',
      selection: 'rgba(120, 220, 232, 0.2)', // Stellar blue with transparency
      border: 'rgba(120, 220, 232, 0.1)', // Subtle stellar border
      hover: 'rgba(120, 220, 232, 0.05)', // Subtle hover state
      focus: 'rgba(171, 157, 242, 0.2)', // Nebula purple focus
    },
  },
});

export default theme;